export default {
  registerIcps: {
    shared: {
      studentCard: {
        question: '¿Eres estudiante?',
        message: ' Accede a una experiencia diseñada para tu aprendizaje ',
      },
      chooseIcp: {
        title: '¿Cómo describes mejor tu trabajo?',
        continueButton: 'Continuar',
        options: {
          SMALL_BUSINESS: {
            title: 'Tengo un negocio y quiero facturar',
            description: 'Crea tus facturas en minutos, envíalas a tus clientes y controla tus ventas.',
          },
          ACCOUNTANT: {
            title: 'Soy contador/a y gestiono varios clientes',
            description:
              'Lleva la contabilidad de tus clientes al día desde un solo lugar y obtén visibilidad de tu negocio.',
          },
          MID_BUSINESS: {
            title: 'Mi empresa ya creció y necesito controlar todo',
            description:
              'Unifica tu contabilidad, facturación, cobros e inventario en una sola plataforma con herramientas inteligentes.',
          },
        },
      },
      recommendation: {
        title: 'Cuéntanos cómo opera tu negocio',
        titleWithIcp: 'Tres preguntas rápidas',
        subtitle: '',
        subtitleWithIcp:
          'Tus respuestas nos permiten recomendarte la solución que mejor se adapta a tu negocio.',
        continueButton: 'Continuar',
        backButton: 'Volver',
        steps: {
          createAccount: 'Crear cuenta',
          aboutBusiness: 'Sobre tu negocio',
          idealSolution: 'Tu solución ideal',
        },
        questions: {
          1: {
            label: '¿Cómo realizas la mayoría de tus ventas?',
            options: {
              a: 'Desde mi negocio o punto de venta físico',
              b: 'A distancia o de forma remota',
            },
          },
          2: {
            label: '¿A quién le vendes principalmente?',
            options: {
              a: 'Al consumidor final o público general',
              b: 'A empresas u organizaciones',
            },
          },
          3: {
            label: '¿Cómo sueles cobrar tus ventas?',
            options: {
              a: 'En el momento con tarjeta, efectivo o transferencia',
              b: 'Emito factura y cobro a crédito',
            },
          },
        },
        analyzing: {
          title: 'Analizando tu negocio...',
          subtitle: 'En un momento te mostramos la solución ideal.',
          status: {
            1: 'Canal de venta evaluado',
            2: 'Tipo de cliente evaluado',
            3: 'Modelo de cobro evaluado',
            4: 'Asignando solución...',
          },
        },
        solution: {
          title: 'Encontramos la solución ideal para ti',
          subtitles: {
            SF: 'Con <strong>{productName}</strong> puedes facturar y controlar tus ventas, todo certificado por la DGII.',
            AC: 'Con <strong>{productName}</strong> puedes facturar, controlar tus gastos y tener tus finanzas al día con la DGII desde un solo lugar.',
            POS: 'Con <strong>{productName}</strong> puedes facturar desde el mostrador, controlar tu inventario y cobrar al instante.',
          },
          answersLabel: 'Estas fueron tus respuestas:',
          startButton: 'Comenzar con {productName}',
          editButton: 'Editar mis respuestas',
          products: {
            SF: 'Alegra Facturación',
            POS: 'Alegra POS',
            AC: 'Alegra ERP',
            NOMINA: 'Alegra Nómina',
          },
        },
      },
      jtbdRecommendation: {
        sublabel: 'Selecciona todo lo que aplique.',
        title: '¿Para qué necesita Alegra?',
        analyzing: {
          title: 'Analizando tu negocio...',
          subtitle: 'En un momento tu solución ideal estará lista.',
          status: {
            2: 'Perfil de tu negocio evaluado',
          },
        },
        jobs: {
          facturar: {
            description:
              'Quiero crear comprobantes válidos ante la DGII y enviarlos directamente a mis clientes.',
          },
          nomina: {
            title: 'Gestionar la nómina de mi equipo',
            description:
              'Quiero calcular los sueldos y las deducciones de mi equipo, en regla y a tiempo.',
          },
        },
        solution: {
          title: 'Esta es tu solución recomendada',
          idealTag: 'Ideal para ti',
          products: {
            NOMINA: 'Alegra Nómina',
          },
          benefits: {
            SF: [
              'Tu primera factura electrónica lista en <br /> menos de una hora.',
              'Tus e-CF cumplen con la DGII, sin rechazos desde el primer día.',
            ],
            POS: [
              'Cobra desde el mostrador en <br /> segundos, con o sin internet.',
              'Tu caja cuadra automáticamente al <br /> cierre del día.',
            ],
            NOMINA: [
              'Tu primera nómina calculada en minutos, con todas las deducciones al día.',
              'Tus reportes para la DGII quedan listos para enviar, con total tranquilidad.',
            ],
          },
        },
      },
    },
    NO_ICP: {
      default: {
        register: {
          hero: {
            title: 'Gestiona tu negocio desde <br /><span class="text-sm-primary-600">un solo lugar</span>.',
            subtitle:
              'Factura, vende y controla tus finanzas con herramientas diseñadas para pymes como la tuya.',
          },
          features: {
            1: 'Cumple al 100% con la DGII de forma fácil, rápida y sin complicaciones.',
            3: 'La IA trabaja contigo para simplificar cada proceso.',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
      POS: {
        register: {
          hero: {
            title: 'Tu punto de venta, más ágil e <span class="text-sm-primary-600">inteligente</span>.',
            subtitle:
              'Registra tus ventas en mostrador, controla el stock al instante y emite facturas electrónicas válidas ante la DGII.',
          },
          features: {
            1: 'Cumple con la DGII desde tu punto de venta: facturación electrónica fácil y rápida.',
            2: 'Crea tu catálogo de productos y servicios una vez y reutilízalos en cada factura.',
            3: 'Controla tu inventario y ventas en tiempo real desde tu punto de venta.',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
      NOMINA: {
        register: {
          hero: {
            title: 'Gestiona la nómina de tu <br />equipo desde <span class="text-sm-primary-600">un solo lugar</span>.',
            subtitle: 'Calcula sueldos, deducciones legales y pagos en minutos.',
          },
          features: {
            1: 'Sueldos, deducciones y horas extra se calculan solos, con la DGII siempre al día.',
            2: 'Tus reportes para la DGII se generan automáticamente, listos para enviar.',
            3: 'Tu nómina se integra con tu contabilidad, así todo tu negocio queda conectado.',
          },
          pills: {
            primary: 'Soy Alegra Nómina',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
    },
    SMALL_BUSINESS: {
      default: {
        register: {
          hero: {
            title: 'Gestiona tu negocio desde <br /><span class="text-sm-primary-600">un solo lugar</span>.',
            subtitle:
              'Cumple con la normativa de la DGII creando tu primera factura electrónica en minutos.',
          },
          features: {
            1: 'Cumple al 100% con la DGII de forma fácil, rápida y sin complicaciones.',
            2: 'Punto de venta ágil con control de inventario en tiempo real.',
            3: 'La IA trabaja contigo para simplificar cada proceso.',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
      POS: {
        register: {
          hero: {
            title: 'Tu punto de venta, más ágil e <span class="text-sm-primary-600">inteligente</span>.',
            subtitle:
              'Registra tus ventas en mostrador, controla el stock al instante y emite facturas electrónicas válidas ante la DGII.',
          },
          features: {
            1: 'Cumple con la DGII desde tu punto de venta: facturación electrónica fácil y rápida.',
            2: 'Crea tu catálogo de productos y servicios una vez y reutilízalos en cada factura.',
            3: 'Controla tu inventario y ventas en tiempo real desde tu punto de venta.',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
      SF: {
        register: {
          hero: {
            title: 'Factura más en menos tiempo con <span class="text-sm-primary-600">ayuda inteligente</span>.',
            subtitle:
              'Cumple con la normativa de la DGII creando tu primera factura electrónica en minutos.',
          },
          features: {
            1: 'Cumple al 100% con la DGII de forma fácil, rápida y sin complicaciones.',
            2: 'Crea tu catálogo de productos y servicios una vez y reutilízalos en cada factura.',
            3: 'Registra tus clientes y envía facturas directamente desde la plataforma.',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
    },
    ACCOUNTANT: {
      default: {
        register: {
          hero: {
            title: 'Gestiona todos tus clientes desde <span class="text-sm-primary-600">un solo lugar</span>.',
            subtitle:
              'Facilita la facturación electrónica obligatoria de todos tus clientes ante la DGII en una misma plataforma.',
          },
          features: {
            1: 'Reportes con IA - Obtén análisis financieros inteligentes en segundos.',
            2: 'Estados financieros, libro diario y reportes tributarios siempre actualizados.',
            3: 'Accede a la información de tus clientes desde cualquier lugar y dispositivo - 100% en la nube.',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
    },
    MID_BUSINESS: {
      default: {
        register: {
          hero: {
            title: 'Gestiona tu negocio desde <br /><span class="text-sm-primary-600">un solo lugar</span>.',
            subtitle:
              'Crea facturas electrónicas válidas ante la DGII fácilmente y controla todas tus finanzas.',
          },
          features: {
            1: 'Cumple al 100% con la DGII de forma fácil, rápida y sin complicaciones.',
            2: 'Punto de venta ágil con control de inventario en tiempo real.',
            3: 'La IA trabaja contigo para simplificar cada proceso.',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
      POS: {
        register: {
          hero: {
            title: 'Tu punto de venta, más ágil e <span class="text-sm-primary-600">inteligente</span>.',
            subtitle:
              'Registra tus ventas en mostrador, controla el stock al instante y emite facturas electrónicas válidas ante la DGII.',
          },
          features: {
            1: 'Cumple con la DGII desde tu punto de venta: facturación electrónica fácil y rápida.',
            2: 'Crea tu catálogo de productos y servicios una vez y reutilízalos en cada factura.',
            3: 'Controla tu inventario y ventas en tiempo real desde tu punto de venta.',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
      AC: {
        register: {
          hero: {
            title: 'Controla tu negocio y tus finanzas <span class="text-sm-primary-600">desde un solo lugar</span>.',
            subtitle:
              'Factura, registra tus gastos y ten tus cuentas al día con la DGII, todo desde una sola plataforma.',
          },
          features: {
            1: 'Facturación electrónica homologada con la DGII, sin rechazos.',
            2: 'Crea tu catálogo de productos y servicios una vez y reutilízalos en cada factura.',
            3: 'Reportes financieros en tiempo real para tomar mejores decisiones.',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
      NOMINA: {
        register: {
          hero: {
            title: 'Gestiona la nómina de tu <br />equipo desde <span class="text-sm-primary-600">un solo lugar</span>.',
            subtitle: 'Calcula sueldos, deducciones legales y pagos en minutos.',
          },
          features: {
            1: 'Sueldos, deducciones y horas extra se calculan solos, con la DGII siempre al día.',
            2: 'Tus reportes para la DGII se generan automáticamente, listos para enviar.',
            3: 'Tu nómina se integra con tu contabilidad, así todo tu negocio queda conectado.',
          },
          pills: {
            primary: 'Soy Alegra Nómina',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
          },
        },
      },
    },
    STUDENT: {
      default: {
        register: {
          hero: {
            title: 'Lleva la teoría a la práctica en <span class="text-sm-primary-600">un solo lugar</span>',
            subtitle: 'Explora la plataforma y practica cómo administrar un negocio.',
          },
          features: {
            1: 'Casos prácticos: registra ventas, compras y analiza los estados financieros a tu ritmo.',
            2: 'Reportes fiscales — ve cómo el sistema calcula los impuestos y genera los reportes.',
            3: 'Practica creando facturas con todos los requisitos.',
          },
          form: {
            title: 'Crea tu cuenta',
            fullName: {
              placeholder: 'Ej.: José Rodríguez',
            },
            email: {
              placeholder: 'Ingresa tu correo electrónico',
            },
            institution: {
              label: '¿Cómo se llama tu institución educativa?',
            },
          },
        },
      },
    },
  },
  register: {
    form: {
      password: {
        placeholder: 'Ingresa una contraseña',
      },
    },
  },
}
